import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MAIN_URL } from 'src/app/news-eng/constant/app-constant';

@Injectable({
  providedIn: 'root'
})
export class HomeService {


  constructor(private http: HttpClient) { }

  getAllNews(ids?: any): Observable<any> {
    return this.http.get<any>(MAIN_URL + "post/allpost/"+ids);
  }
  getStickyNews(): Observable<any> {
    return this.http.get<any>(MAIN_URL + "post/sticky");
  }
  getPostByPostName(post_name: string,date:string): Observable<any> {
    return this.http.get<any>(MAIN_URL + "post/postbyname/" + post_name + "/"+date+"");
  }
  getPostByCategory(id: number, limit: number,ids?: any): Observable<any> {
    return this.http.get<any>(MAIN_URL + "post/categoryPostPaginationNew/" + id + "/0/" + limit + "/"+ids);
  }

  getPostById(id: number) {
    return this.http.get<any>(MAIN_URL + "post/post/" + id + "");
  }
  // getlatestNews(page: number,limit:number):Observable<any>{
  //   return this.http.get<any>(MAIN_URL + "post/allpost");
  // }

  getCovidNews() {
    return this.http.get<any>('https://www.hpb.health.gov.lk/api/get-current-statistical/');
  }
  getCoivdDetails() {
    return this.http.get<any>(MAIN_URL + "post/categoryPostPagination/91504/0/3/");
  }
  getWeather() {

    const headers = new HttpHeaders().append('Content-Type', 'text/xml').append('Accept', 'text/xml').set('access-control-allow-origin', '*');
    return this.http.get<any>(MAIN_URL + "post/weather");

  }


  getExchangeRate() {
    return this.http.get<any>(MAIN_URL + "post/exchange");
  }
  getCoivdDetailsPagination() {
    return this.http.get<any>(MAIN_URL + "post/categoryPostPagination/91504/1/5/");
  }

}
